'use client';

import type { ReactNode } from 'react';
import { useCartStore } from 'stores/cart';

interface CartContentVisibilityProps {
  articleIds: number[];
  fallback: ReactNode;
  children: ReactNode;
}

/**
 * CartContentVisibility - Swaps cart content for the fallback once every article is deleted client-side
 *
 * Deletes are server-confirmed before landing in deletedArticleIds, so the empty state
 * can show without waiting for the RSC re-render.
 */
export function CartContentVisibility({ articleIds, fallback, children }: CartContentVisibilityProps) {
  const deletedArticleIds = useCartStore(s => s.deletedArticleIds);
  const isAllDeleted = articleIds.length > 0 && articleIds.every(id => deletedArticleIds.includes(id));

  if (isAllDeleted) return <>{fallback}</>;

  return <>{children}</>;
}
